"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var AccordionCollapse_1 = require("./AccordionCollapse");
var Icon_1 = require("../Icon");
var Tooltip_1 = require("../Tooltip");
var Panel_1 = require("../Panel");
var IconSymbols_1 = require("../../generated/IconSymbols");
var enums_1 = require("../../enums");
var Accordion = /** @class */ (function (_super) {
    __extends(Accordion, _super);
    function Accordion(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            active: _this.props.active ? true : false
        };
        return _this;
    }
    Accordion.prototype.toggleItem = function () {
        this.setState({
            active: !this.state.active
        }, this.props.onClick);
    };
    Accordion.prototype.render = function () {
        var _this = this;
        var props = this.props, state = this.state, cls = props.className || "";
        var isActive = state.active;
        var activeCls = isActive ? "expanded" : "collapsed";
        var icon = isActive
            ? IconSymbols_1.IconSymbols.ChevronUp
            : IconSymbols_1.IconSymbols.ChevronDown;
        return ((0, jsx_runtime_1.jsx)("div", __assign({ id: props.id, className: "accordion ".concat(cls, " accordion--").concat(props.side || "right") }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "accordion-item accordion__item--".concat(activeCls) }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "accordion-item__header accordion-item__header--".concat(activeCls) }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ onClick: function () { return !props.isArrowInteractiveOnly && _this.toggleItem(); } }, { children: [props.header, !props.hideArrow && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "accordion-item__icon", onClick: function () {
                                            return props.isArrowInteractiveOnly && _this.toggleItem();
                                        } }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { symbol: icon, size: enums_1.Enums.UiSizes.MD }) })))] })), props.actions && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "accordion__actions" }, { children: (0, jsx_runtime_1.jsx)(Tooltip_1.Tooltip, __assign({ position: Tooltip_1.TooltipPositions.LEFT, shownElement: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { symbol: IconSymbols_1.IconSymbols.DotsHorizontal }), triggeredOn: "click", className: "float-right", testId: props.testId }, { children: (0, jsx_runtime_1.jsx)(Panel_1.Panel, __assign({ background: Panel_1.PanelBackgrounds.BG_WHITE, hasShadow: true }, { children: props.actions })) })) })))] })), (0, jsx_runtime_1.jsx)(AccordionCollapse_1.AccordionCollapse, __assign({ isDynamicallyLoaded: props.isDynamicallyLoaded, isOpen: isActive }, { children: props.children }))] })) })));
    };
    Accordion.defaultProps = {
        children: [],
        active: false,
        isArrowInteractiveOnly: false
    };
    return Accordion;
}(React.Component));
exports.Accordion = Accordion;
